import { render, staticRenderFns } from "./AefFaqPage.vue?vue&type=template&id=e37e2fc4&"
import script from "../../../public/js/img/Discoveryjs/Aef_Automate/AefFaqPage.js?vue&type=script&lang=js&"
export * from "../../../public/js/img/Discoveryjs/Aef_Automate/AefFaqPage.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports